var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foots",attrs:{"id":"foots"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-bottom",on:{"click":_vm.toLink}},[_vm._v("\n      "+_vm._s(_vm.basicInfo.archiveInformation)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa36b492","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comment/foots.vue
// module id = null
// module chunks = 